<template>
  <span class="device">
    <SvgIcon class="icon" :iconClass="sourceList[source].icon" />
    <!--{{ sourceList[source].text }}-->
  </span>
</template>

<script>
export default {
  name: "deviceSource",
  mixins: [],
  props: {
    source: {
      type: [String, Number],
      default: 0
    },
    fontSize: {
      type: Number,
      default: 12
    }
  },
  model: {},
  components: {},
  data() {
    return {
      sourceList: {
        0: {
          icon: "pc-icon",
          text: "网页",
          color: "#FF591D"
        },
        1: {
          icon: "pc-icon",
          text: "PC",
          color: "#FF591D"
        },
        2: {
          icon: "wap-icon",
          text: "WAP",
          color: "#FF591D"
        },
        3: {
          icon: "android-icon",
          text: "安卓",
          color: "#A5CA39"
        },
        4: {
          icon: "ios-icon",
          text: "苹果",
          color: "#333333"
        }
      }
    };
  },
  computed: {},
  methods: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style scoped lang="less">
.device {
  margin-left: 5px;
  font-weight: initial;

  i {
    margin-right: 2px;
  }
}
</style>
